import { basicSubscription, premiumSubscription } from '../constantValues/ConstantValues';
import { getCurrentUserCreatorGroup } from './UtilFunctions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const hasExpired = (workspace: any): boolean => {
  if (!workspace) return false;
  return workspace.expired?.S === 'true';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCurrentWorkspaceActivePackage = (groupsList: any[], currentUserGroup: string): string | undefined => {
  const currentWorkspace = groupsList.find((group) => group.id.S === currentUserGroup);
  return currentWorkspace?.monthlyCharge?.N;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWorkspaceActivePackage = (workspace: any): string | undefined => {
  return workspace?.monthlyCharge?.N;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPackageType = (currentUserInfo: any, groupsList: any[]): string => {
  const currentUserCreatorGroup = getCurrentUserCreatorGroup(currentUserInfo, groupsList);
  const activePackage = getWorkspaceActivePackage(currentUserCreatorGroup);
  const userHasNoCreatedGroups =
    groupsList.find((group) => group.creator.S === currentUserInfo.user.S) === undefined;
  if (activePackage && parseInt(activePackage, 10) !== 0) {
    if (parseInt(activePackage, 10) === 7900) return 'Standard';
    if (parseInt(activePackage, 10) === 18900) return 'Premium';
    return 'Custom';
  }
  if (userHasNoCreatedGroups) return 'Invited';
  return hasExpired(currentUserCreatorGroup) ? 'Expired' : 'Free trial';
};

export const getPackageTypeStr = (packageType: string): string | undefined => {
  switch (packageType) {
    case 'Standard': return `Standard (${basicSubscription.price})`;
    case 'Premium': return `Premium (${premiumSubscription.price})`;
    case 'Custom': return 'Custom';
    case 'Expired': return 'Expired';
    case 'Free trial': return 'Free trial';
    default: return undefined;
  }
};

export const getSubscriptionStaticInfo = (packageType: string) => {
  if (packageType === 'Standard' || packageType === 'Free trial') return basicSubscription;
  if (packageType === 'Premium') return premiumSubscription;
  return undefined;
};
